import { useAuth } from "../../auth/AuthContext";
import FinanceMePage from "./FinanceMePage";
import FinanceOverviewPage from "./FinanceOverviewPage";

/** /finance — customers (view_own, not internal) get their own account;
 * internal users (assigned/all) get the cross-customer overview. */
export default function FinancePage() {
  const { hasPermission, state } = useAuth();
  const internal = state.status === "authenticated" && state.user.internal;
  const seesOverview = hasPermission("finance:view_assigned") || hasPermission("finance:view_all");
  if (internal && seesOverview) return <FinanceOverviewPage />;
  return <FinanceMePage />;
}
